import {Directive, ElementRef, EventEmitter, HostListener, Input, OnDestroy, Output} from '@angular/core';

@Directive({
  selector: '[appDynamicColumnWidth]',
})
export class DynamicColumnWidthDirective implements OnDestroy {
  @Input() headerItem: any;
  @Output() widthChange = new EventEmitter<number>();

  private mouseDown = false;
  private dragged = false;
  private startX = 0;
  private startWidth = 0;

  private onDocumentMousemove = (e: MouseEvent) => {
    if (!this.mouseDown) { return; }
    const newWidth = Math.max(40, this.startWidth + (e.x - this.startX));
    if (this.headerItem) {
      this.dragged = true;
      this.headerItem.width = newWidth;
    }
  }

  private onDocumentMouseup = (e: MouseEvent) => {
    if (!this.mouseDown) { return; }
    const newWidth = Math.max(40, this.startWidth + (e.x - this.startX));
    this.mouseDown = false;
    this.el.nativeElement.style.cursor = '';
    document.body.style.cursor = '';
    document.removeEventListener('mousemove', this.onDocumentMousemove);
    document.removeEventListener('mouseup', this.onDocumentMouseup);
    this.widthChange.emit(newWidth);
  }

  // 在 capture 阶段拦截 click，防止拖拽后触发 ng-zorro th-addon 的排序
  // th-addon 的 click 绑定在子组件 host 上，stopPropagation 在冒泡阶段无效，必须用 capture
  private onDocumentClickCapture = (e: MouseEvent) => {
    if (this.dragged) {
      this.dragged = false;
      e.stopPropagation();
      e.preventDefault();
    }
    document.removeEventListener('click', this.onDocumentClickCapture, true);
  }

  constructor(private el: ElementRef) {}

  @HostListener('mousemove', ['$event'])
  onMousemove(e: MouseEvent) {
    if (!this.mouseDown) {
      this.el.nativeElement.style.cursor =
        e.offsetX > this.el.nativeElement.offsetWidth - 8 ? 'col-resize' : '';
    }
  }

  @HostListener('mousedown', ['$event'])
  onMousedown(e: MouseEvent) {
    if (e.offsetX > this.el.nativeElement.offsetWidth - 8) {
      this.mouseDown = true;
      this.startX = e.x;
      this.startWidth = this.el.nativeElement.offsetWidth;
      e.preventDefault();
      document.body.style.cursor = 'col-resize';
      document.addEventListener('mousemove', this.onDocumentMousemove);
      document.addEventListener('mouseup', this.onDocumentMouseup);
      // 注册 capture 阶段的 click 拦截，准备在拖拽后消费掉这次 click
      document.addEventListener('click', this.onDocumentClickCapture, true);
    }
  }

  ngOnDestroy() {
    document.removeEventListener('mousemove', this.onDocumentMousemove);
    document.removeEventListener('mouseup', this.onDocumentMouseup);
    document.removeEventListener('click', this.onDocumentClickCapture, true);
  }
}
